<template>
  <div>
    <NewEditIwlDashboard
      :visible="showNewIwlDialog"
      :application="app"
      @close="showNewIwlDialog = false"
    />
    <data-table
      :headers="appHeaders"
      v-model="iwlData"
      :items-per-page="10"
      title="Iwl Applications"
      filterable
    >
      <!-- SDB-641 hide for future reference -->
      <!-- <template v-slot:item.iwlr_action="{ item }">
        <LoadingIconButton
          tooltip="Edit this app"
          @click="openIwlEditForm(item)"
        >
          edit
        </LoadingIconButton>
        <LoadingIconButton
          tooltip="Delete this app"
          @click="deleteIwlItem(item)"
        >
          clear
        </LoadingIconButton>
      </template> -->
    </data-table>
    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";
import NewEditIwlDashboard from "@/pages/NewEditIwlDashboard.vue";

export default {
  components: {
    DataTable,
    LoadingIconButton,
    ...ValidatedInputs,
    NewEditIwlDashboard
  },
  created() {
    this.getAndUpdateIWLRBasket();
  },
  data() {
    return {
      newObject: false,
      headers: [
        { text: 'id', value: 'id' },
        { text: 'Name', value: 'name' },
      ],
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      showOptInAuctionEditForm: false,
      app: {},
      originalItem: {}, //initial state OptIn when page is loaded
      showIwlrDeals: false,
      appHeaders: [
        {
          text: "Type",
          value: "type",
          sort: true,
          search: true
        },
        {
          text: "Provider",
          value: "provider",
          sort: true,
          search: true
        },
        {
          text: "Policy Number",
          value: "serial_number",
          sort: true,
          search: true
        },
        {
          text: "Client First Name",
          value: "client_first_name",
          sort: true,
          search: true
        },
        {
          text: "Client Last Name",
          value: "client_last_name",
          sort: true,
          search: true
        },
        {
          text: "Created On",
          value: "created_at",
          sort: false,
        },
        // SDB-641 for future implementation
        // {
        //   text: "Action",
        //   value: "iwlr_action",
        //   sort: false,
        // },
      ],
      iwlData: [],
      showNewIwlDialog: false,
    };
  },
  methods: {
    openIwlEditForm(selectedItem) {
      if (Object.keys(selectedItem).length === 0) {
        // new
        this.newObject = true;
      }
      else { //update
        this.newObject = false;
      }
      this.app = selectedItem;
      this.originalItem = { ...selectedItem };
      this.showNewIwlDialog = true;
    },
    async getAndUpdateIWLRBasket() {
      try {
        let res = await axios.get('/api/v1/tools/get_iwlr_deals');
        this.iwlData.length = 0;
        for (const item of res.data) //map db object to necessary front list object
        {
          const element = {
            id: item.id,
            type: item.type,
            provider: item.provider,
            client_first_name: item.client_first_name,
            client_last_name: item.client_last_name,
            serial_number: item.serial_number,
            product: item.product,
            cover_term: item.cover_term,
            premium: item.premium,
            income: item.income,
            client_phone: item.client_phone,
            client_email: item.client_email,
            created_at: new Date(item.created_at).toLocaleString()
          };
          this.iwlData.push(element);
        }
      } catch(error) {
        console.error('IWLRBasket request failed');
        console.error(error);
      }
    },
    ...filters
  },
  computed: {
    ...mapGetters([
      'options',
    ]),
  },
  filters: {
    ...filters
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.dialogWrapper {
  padding: 30px;
}

.error-message {
  color: red;
  padding: 6px;
  margin: 15px 30px;
  text-align: center;
}
</style>
